import { RESET_SELECTED_ROWS } from './actionTypes';

const resetSelectedRows = () => ({
    type: RESET_SELECTED_ROWS,
});

export default resetSelectedRows;
